import { Link } from 'react-router-dom';
import { newsArticles } from '@/mocks/sports';

export default function NewsSection() {
  const featured = newsArticles.slice(0, 1)[0];
  const rest = newsArticles.slice(1, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              体育资讯
            </h2>
            <p className="text-sm text-foreground-500 mt-1">最新体育新闻与深度分析</p>
          </div>
          <Link
            to="/category/football"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            更多资讯 <i className="ri-arrow-right-line text-xs w-4 h-4 flex items-center justify-center"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-5">
          <Link
            to={`/article/${featured.id}`}
            className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:shadow-md transition-all duration-200 cursor-pointer"
          >
            <div className="relative h-56 md:h-72 overflow-hidden">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <span className="text-xs font-medium text-accent-500 bg-black/40 px-2 py-0.5 rounded">{featured.categoryName}</span>
                <h3 className="text-lg md:text-xl font-bold text-white mt-2 leading-snug">{featured.title}</h3>
                <p className="text-sm text-white/70 mt-1 line-clamp-2">{featured.excerpt}</p>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-4">
            {rest.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 p-4 flex gap-4 hover:shadow-md transition-all duration-200 cursor-pointer"
              >
                <div className="w-28 h-20 md:w-36 md:h-24 rounded overflow-hidden flex-shrink-0">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="text-xs font-medium text-accent-500">{article.categoryName}</span>
                    <span className="text-xs text-foreground-400">{article.date}</span>
                  </div>
                  <h3 className="font-semibold text-sm md:text-base text-foreground-900 line-clamp-2 group-hover:text-primary-500 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-1 line-clamp-1 hidden sm:block">{article.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}